import {h, Fragment} from "preact"
export default function SearchHeader() {

    return (
        <div class="template-search__header page-width scroll-trigger animate--fade-in">
            <h2 class="template-search__header-inner h2 center">Resultados de búsqueda</h2>
        </div>
    )
}